import { useTranslations } from 'next-intl';
import { liveChatButtonStyles } from './live-chat-button.style';
import Image from 'next/image';
import { useAthenaCustomSetting } from '@/hooks/query/athena/use-athena-custom-setting';
import { windowService } from '@/services/jupiter/window-service';
import windowNameKeys from '@/constants/window-name-keys';


export const LiveChatButton = () => {
	const t = useTranslations('General');
	const { data: athenaCustomSetting } = useAthenaCustomSetting();

	const openLiveChatUrl = () => {
		if (athenaCustomSetting?.LiveChatUrl) {
			windowService.openWindow(windowNameKeys.LIVECHAT, athenaCustomSetting.LiveChatUrl, '_blank');
		}
	}

	return athenaCustomSetting?.LiveChatUrl ? (
		<div className={liveChatButtonStyles.button} onClick={openLiveChatUrl}>
			<div className={liveChatButtonStyles.icon}>
				<Image
					src={'/images/sign-up/live-chat.png'}
					alt="live"
					width={32}
					height={40}
				/>
			</div>
			<div className={liveChatButtonStyles.text}>{t('lbl_LiveChat')}</div>
		</div>
	) : null;
};

